import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Icon from 'brandComponents/Icon';

import SvgSprite from '../SvgSprite';

import styles from './OfflineBanner.module.scss';

const OfflineBanner = () => {
	const intl = useIntl();

	return (
		<div className={cn(styles['offline-banner'])}>
			<SvgSprite />
			<header>
				<div className={cn(styles['offline-banner-logo'])}>
					<Icon
						name="casadei-logo"
						classNames="header__logo-img"
					/>
				</div>
			</header>
			<main>
				<div className={cn(styles['offline-banner-content'])}>
					{intl.formatMessage({
						id: 'offline_banner.description.browsing_offline_mode',
						defaultMessage: "You're currently browsing in offline mode"
					})}
				</div>
			</main>
		</div>
	);
};

export default OfflineBanner;
